import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`

	0%,90% ,100%{
		width:50px;
		height:50px;
	}
	50%{
		width:75px;
		height:75px;	
	}
`;

const myspin = keyframes`

	0%{
		transform:rotate(0deg);
	}
	100%{
		transform:rotate(90deg);
	}
`;

export const Box = styled.div`
	position:relative;
	width:40px;
	height:40px;
	transform-style:preserve-3d;
	transform-origin:center;
	transform:rotate(45deg);
	animation:${spin} 1s linear infinite;

span:first-of-type{
	position:absolute;
	width:20px;
	height:20px;
	animation:${myspin} 1s ease-in-out infinite;
	left:0px;
	top:0px;
	
	background:#2D9CDB;
}
span:nth-of-type(2){
	position:absolute;
	width:20px;
	height:20px;
	animation:${myspin} 1s ease-in-out infinite;
	right:0px;
	top:0px;
	background:#000000;
}
span:nth-of-type(3){
	position:absolute;
	width:20px;
	height:20px;
	animation:${myspin} 1s ease-in-out infinite;
	left:0px;
	bottom:0px;
	background:#000000;
}
span:last-of-type{
	position:absolute;
	width:20px;
	height:20px;
	animation:${myspin} 1s ease-in-out infinite;
	right:0px;
	bottom:0px;
	background:#2D9CDB;
}`;


interface DataParam {
	minHeight?: string;
}

export const LoaderLayout = styled.div<DataParam>`
	justify-content:center;
	width: 100%;

	min-height: ${({ minHeight }) => (minHeight !== '' ? minHeight : '50%')};
`;

export const StyledLoader: React.FC<DataParam> = (props) => {
	const { minHeight = '' } = props;
	return (
		<>
			<LoaderLayout minHeight={minHeight} style={{ display: 'flex', alignItems: 'center',marginBottom:"-10%" }}>
				{/* <Spinner /> */}
				<Box>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</Box>
			</LoaderLayout>
		</>
	);
};

export default StyledLoader;
